import {translations} from 'presentation/translations-new';

const {stepsTitleMobile} = translations['pt-br'].privateFlow.bookingFlow;
const {neighborhood, unit, professional, exam, confirm, location: locationTitle} = stepsTitleMobile;

const HEADER_TITLES = {
	withGeo: [locationTitle, exam, unit, professional, confirm],
	withoutGeo: [locationTitle, exam, neighborhood, unit, professional, confirm],
};

export {HEADER_TITLES};
